/**
 * @voltxampere/engine — PULSE source AC stamp (Sprint 22 B2)
 *
 * The PULSE waveform has zero AC small-signal content — it is a
 * pure transient stimulus. The AC stamp therefore only writes the
 * augmented MNA row's structural coefficients (unity entries
 * connecting the source's branch current to its terminals); the
 * RHS imag/real entries are zero.
 *
 * Pattern matches `voltage-source` AC behaviour for a source whose
 * `acMagnitude` is unset.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ContractViolationError } from "@voltxampere/shared";
import { getTerminalNetId } from "../terminal-utils.js";
export const pulseSourceACStamp = (ctx, component) => {
    const pos = ctx.nodeIndex(getTerminalNetId(component, "pos"));
    const neg = ctx.nodeIndex(getTerminalNetId(component, "neg"));
    const k = ctx.vSourceIndex(component.id);
    if (k < 0) {
        throw new ContractViolationError(`pulseSourceACStamp: component "${component.id}" missing augmented row`);
    }
    ctx.addY(pos, k, 1, 0);
    ctx.addY(neg, k, -1, 0);
    ctx.addY(k, pos, 1, 0);
    ctx.addY(k, neg, -1, 0);
    // RHS stays zero — pulse has no AC small-signal component.
};
//# sourceMappingURL=pulse-source.js.map